import { Observable } from "rxjs";
import { BRANDSETTINGS } from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const fetchPreferredRetailersEpic = (action$, store) => {
    return action$
        .ofType(BRANDSETTINGS.PREFERREDRETAILERS.FETCH.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap(() => {
            return ajax({
                method: "GET",
                url: `${siteConfig.api}/brand/preferred-retailers`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false, status };
                    } else {
                        return { error: true, result: response, status };
                    }
                })
                .flatMap(({ result, error, status }) => {
                    if (error) {
                        return [
                            store.dispatch(
                                snackbarAdd({ message: formatMessage("Error fetching preferred retailers") })
                            ),
                            {
                                payload: error,
                                error: true,
                                type: BRANDSETTINGS.PREFERREDRETAILERS.FETCH.COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                error: false,
                                type: BRANDSETTINGS.PREFERREDRETAILERS.FETCH.COMPLETED,
                            },
                        ];
                    }
                })
                .catch((error) => {
                    const errorMessage = formatMessage("Error fetching preferred retailers");
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRANDSETTINGS.PREFERREDRETAILERS.FETCH.COMPLETED,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};

export const updatePreferredRetailersEpic = (action$, store) => {
    return action$
        .ofType(BRANDSETTINGS.PREFERREDRETAILERS.UPDATE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((rule) => {
            return ajax({
                method: "PATCH",
                body: rule,
                url: `${siteConfig.api}/brand/preferred-retailers`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: response };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error saving preferred retailers") })),
                            {
                                payload: [],
                                error: true,
                                type: BRANDSETTINGS.PREFERREDRETAILERS.UPDATE.COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Preferred retailers updated") })),
                            {
                                payload: result,
                                error: false,
                                type: BRANDSETTINGS.PREFERREDRETAILERS.UPDATE.COMPLETED,
                            },
                        ];
                    }
                })
                .catch((error) => {
                    const errorMessage = formatMessage("Error saving preferred retailers");
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRANDSETTINGS.PREFERREDRETAILERS.UPDATE.COMPLETED,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};
